import { SettingPenName } from './SettingPenName'
import { withSettingPenName } from './withSettingPenName'

const ConnectedSettingPenName = withSettingPenName(SettingPenName)

export { ConnectedSettingPenName as SettingPenName }
